import { render, staticRenderFns } from "./FccSolicitacoesEspecificasPublicacao.vue?vue&type=template&id=63416aac"
import script from "./FccSolicitacoesEspecificasPublicacao.vue?vue&type=script&lang=js"
export * from "./FccSolicitacoesEspecificasPublicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports